import { FormattedMessage } from "react-intl"
import { Fragment } from "react/jsx-runtime"

interface Props {
  isCardPage: boolean
}
export const PersonalInfo = ({ isCardPage }: Props) => {
  return (
    <Fragment>
      <h4 className="h4 welcome-info__title text-left">
        <FormattedMessage id="pa_152" />
      </h4>
      <span className="welcome-info__verefy__text">
        <FormattedMessage id="pa_153" />
      </span>
      {isCardPage ? (
        <>
          <p className="welcome-info__verefy-descr">
            <FormattedMessage id="ver-1" />
          </p>
          <ul className="welcome-info__controls verefy-info__controls list">
            <li className="welcome-info__verefy-list done">
              <FormattedMessage id="ver-2" />
            </li>
            <li className="welcome-info__verefy-list done">
              <FormattedMessage id="ver-3" />
            </li>
            <li className="welcome-info__verefy-list done">
              <FormattedMessage id="ver-4" />
            </li>
            <li className="welcome-info__verefy-list done">
              <FormattedMessage id="ver-5" />
            </li>
          </ul>
        </>
      ) : (
        <>
          <p className="welcome-info__verefy-descr">
            <FormattedMessage id="pa_154" />
            <br />
            <FormattedMessage id="pa_155" />
          </p>
          <ul className="welcome-info__controls verefy-info__controls list">
            {/*<li className="welcome-info__verefy-list done">
              <FormattedMessage id="pa_156" />
            </li>*/}
            <li className="welcome-info__verefy-list done">
              <FormattedMessage id="pa_157" />
            </li>
            <li className="welcome-info__verefy-list done">
              <FormattedMessage id="pa_158" />
            </li>
          </ul>
        </>
      )}

      <button className="welcome-info__button-link button button-sm button-dark-blu">
        <FormattedMessage id="ver-6" />
      </button>
    </Fragment>
  )
}
